export const V2_ECHARTS_THEME_NAME = "v2-energy-cockpit";

export const v2EchartsTheme = {
  color: ["#36f1dc", "#3aa5ff", "#f5d94c", "#ff935b", "#7a6cff"],
  backgroundColor: "transparent",
  textStyle: {
    color: "#83add2",
    fontFamily: "Microsoft YaHei, sans-serif",
  },
  title: {
    textStyle: { color: "#e8f5ff", fontWeight: 600 },
    subtextStyle: { color: "#6e9bc3" },
  },
  legend: {
    textStyle: { color: "#8eb5d6" },
  },
  tooltip: {
    backgroundColor: "rgba(2, 16, 44, .94)",
    borderColor: "rgba(54, 241, 220, .52)",
    textStyle: { color: "#e8f5ff" },
  },
  categoryAxis: {
    axisLine: { lineStyle: { color: "#24538a" } },
    axisTick: { show: false },
    axisLabel: { color: "#759fc5" },
    splitLine: { lineStyle: { color: "rgba(55, 126, 198, .14)" } },
  },
  valueAxis: {
    axisLine: { lineStyle: { color: "#24538a" } },
    axisTick: { show: false },
    axisLabel: { color: "#759fc5" },
    splitLine: { lineStyle: { color: "rgba(55, 126, 198, .14)" } },
  },
};

let registered = false;

export function registerV2EchartsTheme(echarts) {
  if (registered) return V2_ECHARTS_THEME_NAME;
  echarts.registerTheme(V2_ECHARTS_THEME_NAME, v2EchartsTheme);
  registered = true;
  return V2_ECHARTS_THEME_NAME;
}
